import { MinLength, Length } from 'class-validator';

export class SolicitudValidate {
    @MinLength(1)
    TipoDoc: string;
    @Length(1, 12)
    DocIden: string;
    @Length(1, 100)
    Nombre: string;
    @Length(1, 60)
    Direccion: string;
    @Length(1, 40)
    Poblacion: string;
    @Length(1, 20)
    Provincia: string;
    @Length(5, 5)
    Cpostal: string;
    @MinLength(1)
    Nacion: string;
    @MinLength(1)
    Nacionalidad: string;
    @Length(1, 34)
    Iban: string;
    @Length(1, 11)
    Bic: string;
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/SolicitudValidate.entity.ts